export const sr = {
  nav: {
    features: "Rešenja",
    products: "Proizvodi",
    about: "O nama",
    contact: "Kontakt",
  },
  hero: {
    badge: "Profesionalna bezbednosna rešenja",
    title: "Kompletna zaštita vašeg prostora",
    subtitle: "IP kamere, video interfoni, kontrola pristupa i alarmni sistemi za dom i biznis. Više od 15 godina iskustva.",
    ctaPrimary: "Pogledajte proizvode",
    ctaSecondary: "Besplatna konsultacija",
  },
};